import React from 'react';
import { OptimizedImage } from '../common';

export const MissionSection: React.FC = () => {
  return (
    <section id="mission-section-about" className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-Color-Scheme-1-Background">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <h2 className="mb-5 text-4xl md:text-5xl font-bold font-gabarito text-Color-Scheme-1-Text dark:text-Color-Neutral-Lightest md:mb-6 leading-tight">
              Our Mission
            </h2>
            <p className="text-lg text-Color-Scheme-1-Text dark:text-Color-Neutral-Light font-cairo">
              We believe AI should empower humanity, not replace it. Our goal is
              to create intelligent systems that augment human capabilities and
              make complex tasks accessible to everyone.
            </p>
          </div>
          <div className="relative h-[400px] md:h-[500px] lg:h-[640px] rounded-2xl overflow-hidden">
            <OptimizedImage
              src="/images/018.mission.jpeg" 
              alt="Our Mission" 
              className="rounded-2xl"
              sizes="(max-width: 768px) 100vw, 50vw"
            />
          </div>
        </div>
      </div>
    </section>
  );
};